document.addEventListener('DOMContentLoaded', function(){
  // placeholder
  setPlaceHolder();
  // inputChange
  if($('.js-inputChange').length > 0) inputChange($('.js-inputChange'));
  // body の閉じタグ直前にモーダル用のマークアップを追加する
  document.body.insertAdjacentHTML('beforeend','<div id="confirm-overlay"></div>');
  // 第1希望
  pikaday( 'kibo_first' );
  // 第2希望
  pikaday( 'kibo_second' );
  // 第3希望
  pikaday( 'kibo_third' );
  // 日付を消去する
  clearValue( '.js-clear-value' );



  // jQuery Validate Plugin
  //

  // form id name
  const formID = '#contactForm';

  // Rules
  const rules = {
    // お問い合わせ種別
    category: {
      required: true
    },
    kibo_first: {
      required: function(){
        const value = $('input[name=category]:checked').val();
        return ( value === '施設見学' ) ? true : false;
      }
    },
    lastName: { // 名前
      required: true
    },
    firstName: { // 名前
      required: true
    },
    lastNameKana: { // 名前（フリガナ）
      required: true,
      kana: true
    },
    firstNameKana: { // 名前（フリガナ）
      required: true,
      kana: true
    },
    mail: {
      required: true,
      halfchara: true,
      mail: true
    },
    mailEqual: {
      required: true,
      halfchara: true,
      mail: true,
      equalTo: '[name=mail]'
    },
    zip: {
      required: true
    },
    address: {
      required: true
    },
    tel: {
      required: true,
      tel: true,
      number: true
    },
    etcetera: {
      required: function(){
        const value = $('input[name=relationship]:checked').val();
        return ( value === 'その他' ) ? true : false;
      }
    },
    level: {
      required: function(){
        const value = $('input[name=insurance]:checked').val();
        return ( value === '申請済み' ) ? true : false;
      }
    },
    privacy: {
      required: true
    }
  };

  // message
  const messages = {
    category: {
      required: '選択してください'
    },
    kibo_first: {
      required: '入力してください'
    },
    lastName: {
      required: '入力してください'
    },
    firstName: {
      required: '入力してください'
    },
    lastNameKana: {
      required: '入力してください',
      kana: '全角ひらがな・カタカナで入力してください'
    },
    firstNameKana: {
      required: '入力してください',
      kana: '全角ひらがな・カタカナで入力してください'
    },
    mail: {
      required: '入力してください',
      halfchara: '正しいメールアドレスを入力してください',
      mail: '正しいメールアドレスを入力してください'
    },
    mailEqual: {
      required: '入力してください',
      halfchara: '正しいメールアドレスを入力してください',
      mail: '正しいメールアドレスを入力してください',
      equalTo: 'メールアドレスが違います'
    },
    zip: {
      required: '入力してください'
    },
    address: {
      required: '入力してください'
    },
    tel: {
      required: '入力してください',
      tel: '正しい番号を入力してください。（半角数字・ハイフン不要）',
      number: '正しい番号を入力してください。（半角数字・ハイフン不要）'
    },
    etcetera: {
      required: '入力してください'
    },
    level: {
      required: '選択してください'
    },
    privacy: {
      required: 'チェックしてください'
    }
  };
  // 追加ルールの定義
  const methods = {
    halfchara: function halfchara( value, element ){
      return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
    },
    kana: function number( value, element ){
      return this.optional(element) || /^([ぁ-んァ-ンヴー]+)$/.test(value);
    },
    number: function number( value, element ){
      return this.optional(element) || /^([0-9]+)$/.test(value);
    },
    tel: function tel( value, element ) {
      // 電話番号のバリデーション
      return this.optional(element) || /^\d{10,11}$/.test(value);
    },
    mail: function mail( value, element ) {
      // メールアドレスのバリデーション
      return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
    },
    price: function price( value, element ) {
      // 合計金額が 0 以上か
      return this.optional(element) || ( value > 0 ) ? true : false;
    }
  }
  // メソッドの追加（上記の追加ルールを適用させる）
  $.each( methods, function( key ) {
    $.validator.addMethod( key, this );
  });

  // jQuery Validation Plugin の初期化
  $( formID ).validate({
    rules    : rules,
    messages : messages,
    // フォーカスアウトでバリデーション
    onfocusout: function onfocusout( element ){
      if ( ! this.checkable( element ) ) {
        this.element( element );
      }
    },
    // エラーメッセージの表示位置
    errorPlacement: function errorPlacement( error, element ){
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' );
      error.prependTo( eleName + '_error' );
      //console.log(error);
      //messageElm.innerHTML = error;
    },
    // submit
    submitHandler: function(form){
      const fd = $(form).serialize();
      confirmHandler( 'confirm.contact.php', fd, form );
    }

  }); // jQuery Validation

  // お問い合わせ種別
  //
  // アニメーションスピード
  const animeSpeed = 200;
  const elem = document.getElementsByName('category');
  const slideItem = $('#slideItem');
  elem.forEach( e => e.addEventListener('change', (t) => {
    // 選択した value を取得する
    const value = t.target.value;
    // __last の付け替え
    const lastClassElm = t.target.closest('.formworks-container');
    if( value === '施設見学' ){
      lastClassElm.classList.remove('__last');
      slideItem.slideDown(animeSpeed);
    } else {
      slideItem.slideUp(animeSpeed);
      lastClassElm.classList.add('__last');
    }
  }));

  // リンク元が「施設見学」を指定してきたときに見学予定日を表示させる
  const getQuery = get_query();
  const trip = document.getElementById('trip');
  if( getQuery.categories === 'observation' ){
    const lastClassElm = trip.closest('.formworks-container');
    lastClassElm.classList.remove('__last');
    slideItem.slideDown(animeSpeed);
  } else {
    return;
  }

});



const form = document.forms.contactForm;
const dateClearBtn = document.getElementById('dateClearBtn'); // 日付をクリアする

// ページに戻った際にフォームの内容をクリアする
//window.onpageshow = function(){
//  document.getElementById('contactForm').reset();
//};

/** GET query パラメータを取得 */
const get_query = () =>
{
  if( window.location.search === '' ) return;
  const variables = window.location.search.split('?')[1].split('&');
  const obj = {};
  variables.forEach( function(v, i) {
    const variable = v.split('=');
    obj[variable[0]] = variable[1];
  });
  return obj;
}
